_collow.components.QuizConnectDots = class QuizConnectDots extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  allElements;
  connectElementsColumnA;
  connectElementsColumnB;
  optionClickedColumn;
  lastClickedOptionStyle;
  styleOptions;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    this.connectElementsColumnA = document.querySelectorAll(`.quiz-connect-dots[data-quiz-connect-dots\\:index="${this.params.index}"] [data-connect-optionA]`);
    this.connectElementsColumnB = document.querySelectorAll(`.quiz-connect-dots[data-quiz-connect-dots\\:index="${this.params.index}"] [data-connect-optionB]`);
    this.allElements = [...this.connectElementsColumnA, ...this.connectElementsColumnB];
    this.lastClickedOptionStyle = "";
    this.styleOptions = ["square", "circle", "triangle", "star", "pentagon"];
    this.resetButton = document.querySelector(".question-reset-button")

    this.allElements.forEach(option => option.addEventListener("mouseup", this.handleClickOption));
    this.applyDefaultStyle();

    this.listen(document.body, "_collow.quiz-finished", this.showResults);
    this.resetButton.addEventListener("mouseup", this.resetQuestion)
  }

  applyDefaultStyle = () => {
    this.connectElementsColumnA.forEach((option, index) => {
      const figure = option.querySelector(".figure");
      const style = this.styleOptions[index];
      figure.classList.add(style);
      option.setAttribute("click-style", style);
    });
  };

  handleClickOption = (e) => {
    const clickedOption = e.target.closest(".question-connectable-options");
    if (!clickedOption) return;

    this.optionClickedColumn = clickedOption.getAttribute("column");

    clickedOption.getAttribute("clicked") === "true"
      ? this.unmarkOption(clickedOption)
      : this.markOption(clickedOption);

    this.checkAllDotsConnected();
  };

  unmarkOption = (option) => {
    if (this.optionClickedColumn === "B") return;
    const style = option.getAttribute("click-style");
    const matchedOption = Array.from(this.connectElementsColumnB).find(
      opt => opt.getAttribute("click-style") === style
    );

    if (matchedOption) {
      this.resetOption(matchedOption, style);
    } else {
      this.lastClickedOptionStyle = "";
      option.setAttribute("clicked", "false");
    }
  };

  markOption = (option) => {

    const style = option.getAttribute("click-style");

    if (this.optionClickedColumn === "A" && !this.lastClickedOptionStyle) {
      this.lastClickedOptionStyle = style;
      option.setAttribute("clicked", "true");
    } else if (this.optionClickedColumn === "B" && this.lastClickedOptionStyle) {
      option.setAttribute("clicked", "true");
      option.setAttribute("click-style", this.lastClickedOptionStyle);
      option.querySelector(".figure").classList.add(this.lastClickedOptionStyle);
      this.lastClickedOptionStyle = "";
    }
  };

  resetOption = (option, style) => {
    option.setAttribute("click-style", "");
    option.setAttribute("clicked", "false");
    option.querySelector(".figure").classList.remove(style);
    this.lastClickedOptionStyle = style;
  };

  checkAllDotsConnected = () => {
    if (this.allElements.every(option => option.getAttribute("clicked") === "true")) {
      this.calculateScore();
    }
  };

  calculateScore = () => {
    let rightAnswers = 0;

    this.styleOptions.forEach(style => {
      const options = this.getOptionsByStyle(style);

      if (options.length > 0 && options[0].getAttribute("data-quiz-answer").trim() === options[1].getAttribute("data-quiz-option-text").trim()) {
        rightAnswers++;
      }
    });

    const points = rightAnswers * (this.params.points / (this.allElements.length / 2));
    this.correctAnswer = (this.allElements.length / 2) === rightAnswers;

    this.sendAnswer(points);
  };

  getOptionsByStyle = (style) => {
    return this.allElements.filter(option => option.getAttribute("click-style") === style);
  };

  sendAnswer = (points) => {
    this.dispatch(this.root, "_collow.quiz-points", {
      points,
      index: this.params.index,
    });
  };

  showResults = () => {
    this.dispatch(this.root, "_collow.quiz-finished", { correct: this.correctAnswer }, false);
    this.dispatch(this.root, `_collow.hint-${this.params.index}`, this.correctAnswer);

    this.allElements.forEach(el => el.removeEventListener("mouseup", this.handleClickOption));

    this.styleOptions.forEach(style => {
      const options = this.getOptionsByStyle(style);

      options.forEach(option => {
        option.removeAttribute("click-style");
        option.dataset.quizCorrectAnswer =
          options[0].getAttribute("data-quiz-answer").trim() === options[1].getAttribute("data-quiz-option-text").trim();
      });
    });
  };

  resetQuestion = () => {
    this.allElements.forEach(option => option.setAttribute("clicked", "false"))
    this.connectElementsColumnB.forEach(option => option.removeAttribute("click-style"))
  }
};
